import React from 'react';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import { Paper } from '@mui/material';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import { MAIN_THEME } from '@styles';

interface IDialogConfirmationTemplateProps extends IFormFieldInputBaseProps {
  title?: string;
  description?: string;
  footer?: JSX.Element;
  contentClass?: string;
  children?: React.ReactNode;
}

const useStyles = makeStyles()(() => ({
  templateContainer: {
    width: '90%',
    margin: 'auto',
  },
  header: {
    maxWidth: 300,
  },
  title: {
    font: 'normal',
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.rg,
    color: MAIN_THEME.color.black,
    margin: '20px auto 0px 20px',
  },
  description: {
    textAlign: 'center',
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '16px',
    color: MAIN_THEME.color.black,
    margin: '15px auto 0',
  },
  paperRoot: {
    width: '100%',
    padding: '15px',
  },
  paperHeader: {
    textAlign: 'right',
    height: 65,
    padding: 10,
    boxSizing: 'border-box',
  },
  paperContent: {
    padding: '15px 20px 30px 20px',
    fontSize: MAIN_THEME.fontSize.sm,
  },
  paperFigure: {
    width: '40%',
  },
  paperChildren: {
    width: '60%',
  },
  footer: {
    margin: '0px 20px 20px 0px !important',
  },
}));

const DialogConfirmationTemplate: React.FC<
  IDialogConfirmationTemplateProps
> = ({
  title,
  description,
  footer,
  children,
  className,
  style,
  contentClass,
}) => {
  const { classes } = useStyles();

  return (
    <section
      className={clsx(classes.templateContainer, className)}
      style={style}
    >
      <Paper classes={{ root: classes.paperRoot }} className={contentClass}>
        {(title || description) && (
          <header className={classes.header}>
            {title && <h4 className={classes.title}>{title}</h4>}
            {description && (
              <p className={classes.description}>{description}</p>
            )}
          </header>
        )}
        <div className={classes.paperContent}>{children}</div>
        <div className={classes.footer}>{footer}</div>
      </Paper>
    </section>
  );
};

export default DialogConfirmationTemplate;
